document.addEventListener('DOMContentLoaded', function() {
  const sidebarToggles = document.querySelectorAll('[data-sidebar-toggle]');
  const sidebarCloses = document.querySelectorAll('[data-sidebar-close]');
  const overlay = document.querySelector('.overlay');

  function openSidebar(sidebarId) {
    const sidebar = document.getElementById(sidebarId);
    
    if (sidebar) {
      sidebar.setAttribute('aria-hidden', 'false');
      sidebar.classList.add('shipping-sidebar-open');
    }
  }

  function closeSidebar(sidebarId) {
    const sidebar = document.getElementById(sidebarId);
    
    if (sidebar) {
      sidebar.setAttribute('aria-hidden', 'true');
      sidebar.classList.remove('shipping-sidebar-open');
    }
  }

  // Open sidebar on button click
  sidebarToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const sidebarId = this.getAttribute('data-sidebar-toggle');
      openSidebar(sidebarId);
    });
  });

  // Close sidebar on close button click
  sidebarCloses.forEach(closeBtn => {
    closeBtn.addEventListener('click', function() {
      const sidebarId = this.getAttribute('data-sidebar-close');
      closeSidebar(sidebarId);
    });
  });

  // Close sidebar on overlay click (clicking outside the sidebar)
  if (overlay) {
    overlay.addEventListener('click', function() {
      const openSidebars = document.querySelectorAll('.shipping-sidebar-open');
      openSidebars.forEach(sidebar => {
        closeSidebar(sidebar.id);
      });
    });
  }

});

